import { memo, Fragment } from 'react';
import { findSubstringMatchIndex, getOneEditDistanceMatchPosition } from '@direct-frontend/stdlib';
import styles from './HighlightedText.module.css';

/**
 * Пропсы компонента HighlightedText
 */
export interface HighlightedTextProps {
    /** Имя класса для корневого элемента */
    className?: string;
    /** Текст, в котором ищется подстрока */
    text?: string;
    /** Подстрока, которую надо подсветить */
    search?: string;
    /**
     * Объединить полученные блоки под одним span-ом.
     * Полезно, когда во внешнем блоке есть gap, которого не должно быть в тексте
     */
    joinParts?: boolean;
}

/**
 * Компонент для отображения текста с подсвеченной в нем подстрокой
 * Находит первое вхождение подстроки и оборачивает его в span со стилем подсветки
 * @kind component
 */
export const HighlightedText = memo(function HighlightedText(props: HighlightedTextProps) {
    const { text = '', search = '', joinParts } = props;

    let indexOfSearchValue = findSubstringMatchIndex(text, search);
    let endSearchValueIndex = indexOfSearchValue + search.length;
    if (indexOfSearchValue === -1) {
        const fuzzyMatch = getOneEditDistanceMatchPosition(text, search);

        if (!fuzzyMatch) {
            return <>{text}</>;
        }

        indexOfSearchValue = fuzzyMatch.from;
        endSearchValueIndex = fuzzyMatch.to;
    }

    const Wrapper = joinParts ? 'span' : Fragment;

    return (
        <Wrapper>
            {text.slice(0, indexOfSearchValue)}
            <span className={styles.HighlightedText}>{text.slice(indexOfSearchValue, endSearchValueIndex)}</span>
            {text.slice(endSearchValueIndex, text.length)}
        </Wrapper>
    );
});
